export default __webpack_public_path__ + "0152b665dcea8d1035a2884d5315b752.png";